import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { QueovalParam, BreadcrumbModel, QueovalDik, ReservationStagiaireData, EventsModel, Stage, BObjectModel, CodeIdent } from '../../models';
import { CoreService, HttpService } from '../../services';
import { DialogService } from '../../dialog';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { AgendaQueovalService } from '../agenda.queoval.services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-reservation-stagiaire',
  templateUrl: './reservationstagiaire.component.html',
  styleUrls: ['./reservationstagiaire.component.css']
})

export class ReservationStagiaireComponent implements OnInit, OnDestroy {

  // #region VARIABLES GLOBALES
  public BOAdress: BObjectModel;
  public BOEvent: BObjectModel;
  public Stages: Stage[];
  public infoAdress: BObjectModel;
  public infoRes: BObjectModel;
  public latitude: number;
  public longitude: number;
  public adressMap: string;
  public loadMap: boolean;
  public DataResaStagiaire: ReservationStagiaireData;
  public loadBoAdress: boolean;
  public loadBoEvent: boolean;
  public fulladress: string;
  public strCodeRelationBlocante: { fontAwsome: string, value: string } = { fontAwsome: '', value: '' };
  public dtDebut: Date = new Date(Date.now());
  public dtNow: Date = new Date(Date.now());
  private sub: Subscription;
  private fork: Subscription;

  // #endregion

  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
  @Input('param') param: QueovalParam;
  // #endregion

  // #region CONSTRUCTOR
  constructor(
    public indParam: CoreService,
    private dialogservice: DialogService,
    private httpService: HttpService,
    protected domSanitizer: DomSanitizer,
    public agenda: AgendaQueovalService
  ) { }
  // #endregion


  // #region CYCLE DE VIE
  ngOnInit(): void {
    this.loadBoAdress = false;
    this.loadBoEvent = false;
    this.loadMap = false;
    if (this.param.model) {
      this.dialogservice.showSplash(true);
      this.param.model.ShowRemoveButton = false;
      this.param.model.ShowSaveButton = false;
      this.param.model.IdentBODisplay = "BO_RESERV_PRT";
      const code: QueovalDik[] = this.param.params.filter((element: QueovalDik) => element.key === 'code');
      // tslint:disable-next-line:max-line-length
      this.sub = this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GETINIT/${this.param.model.IdDonneeFils}|${code[0].value}|${this.param.model.IdRelation}|${this.agenda.SelectedCalendarOwnerId}`).subscribe(
        (data: EventsModel) => {
          if (!data.HasError) {
            this.DataResaStagiaire = data.DataResaStagiaire;
            this.latitude = data.DataResaStagiaire.infoAdresse.latitude;
            this.longitude = data.DataResaStagiaire.infoAdresse.longitude;
            this.adressMap = `${data.DataResaStagiaire.infoAdresse.adresse1} ${data.DataResaStagiaire.infoAdresse.adresse2} ${data.DataResaStagiaire.infoAdresse.codePostal} ${data.DataResaStagiaire.infoAdresse.ville}`;
            this.loadMap = true;
            this.dialogservice.showSplash(false);
            // Construction de l'adresse complète pour l'affichage dans la map
            this.fulladress = `${this.DataResaStagiaire.infoAdresse.denomination} ${this.DataResaStagiaire.infoAdresse.adresse1} ${this.DataResaStagiaire.infoAdresse.adresse2} ${this.DataResaStagiaire.infoAdresse.adresse3}`;
            // make a forjoin
            const obs1: Observable<BObjectModel> = this.httpService.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, data.DataResaStagiaire.StageAddress);
            const obs2: Observable<BObjectModel> = this.httpService.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, this.param.model);
            this.fork = forkJoin([obs1, obs2]).subscribe(
              (res: Array<BObjectModel>) => {
                if (!res[0].HasError) {
                  this.BOAdress = res[0];
                  this.loadBoAdress = true;
                }
                if (!res[1].HasError) {
                  this.BOEvent = res[1];
                  this.loadBoEvent = true;
                }
              }
            );
          }
          const arrDate: string[] = this.DataResaStagiaire.infoReservation.debut.replace(/ /g, '/').replace(/:/g, '/').split('/');
          this.dtDebut = new Date(Number(arrDate[2]), Number(arrDate[1]) - 1, Number(arrDate[0]), 0, 0);
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.sub) { this.sub.unsubscribe();}
    if (this.fork) { this.fork.unsubscribe();}
  }
  // #endregion

  // #region public functions

  /**
   * Pour afficher l'image en base 64 et éviter l'erreur (<img src='unsafe:data:image/jpeg;base64,/9.....)
   * @param imgUrl url de l'image
   */
  getUrl(imgUrl: string): string {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl) as string;
  }

  // #endregion
  public catchBlockingRelation(value: string) {
   
    switch (value) {
      case CodeIdent.REL_BO_CONTACT_BO_RESERV_A:
        this.strCodeRelationBlocante.fontAwsome = 'fas fa-times q-c-danger';
        this.strCodeRelationBlocante.value = 'Vous avez justifié votre absence auprès de votre Formateur. Vous ne pouvez pas émarger cette réservation.';
        break;
      case CodeIdent.REL_BO_CONTACT_BO_RESERV_I:
        this.strCodeRelationBlocante.fontAwsome = 'fas fa-exclamation-triangle q-c-danger';
        this.strCodeRelationBlocante.value = 'Votre formateur vous a noté absent. Vous ne pouvez pas émarger cette réservation.';
        break;
      case CodeIdent.REL_BO_CONTACT_BO_RESERV_R:
        this.strCodeRelationBlocante.fontAwsome = 'fas fa-info-circle q-c-primary';
        this.strCodeRelationBlocante.value = 'Vous ne pouvez pas émarger cette réservation car elle a été reporté.';
        break;
    }
  }
}



